import React, { useContext } from 'react';
import axios from 'axios';
import{ useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";


import { Autoplay ,EffectFade, Navigation, Pagination } from "swiper";

import { MoonLoader } from 'react-spinners';
import { useDispatch, useSelector } from 'react-redux';

import { getTrendingSeries } from '../../Redux/tsSlice';


function Series(props) {
  

    const [topRatedSeries,getTopRatedSeries] = useState(null);


    const {data} = useSelector(state => state.trendingSeries)
    

    const dispatch = useDispatch()

    async function getRatedSeries(){
        let {data} = await axios.get("https://api.themoviedb.org/3/tv/top_rated?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US&page=1")
        getTopRatedSeries(data.results)
      }
    async function up(){
       console.log('UP');
       window.scrollTo(0,0);
    }  
      useEffect(() => {
        getRatedSeries();
        dispatch(getTrendingSeries())
        up()
      }, [])



    return <>
    {data && topRatedSeries?<>
      <div className='container my-5'>
        <div className="row">
          <Swiper
        spaceBetween={30}
        effect={"fade"}
        navigation={false}
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Autoplay,EffectFade, Navigation, Pagination]}
        className="mySwiper"
      >
        {data.data.results.map((series, idx) => <SwiperSlide  key={idx}>
          <div className='text-center'>
          <img className='w-75 position-relative rounded-3 overflow-hidden' src={"https://image.tmdb.org/t/p/original/" + series.backdrop_path} />
          <div className='position-absolute layer d-flex justify-content-center align-items-center'>
            <div>
            <h2>{series.name}</h2>
            </div>
          </div>
          </div>
        </SwiperSlide>)}
      </Swiper>

        </div>
    </div>
     <div className="container">
      <div className="row">
        <div className="col-md-4 align-self-center">
          <div>
            <div className='upper'></div>
            <h5>Trending Series to watch now</h5>
            <p className='text-muted'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Illo fuga quibusdam expedita quos non id optio nisi excepturi nostrum iusto maxime necessitatibus soluta suscipit, exercitationem laborum accusantium commodi, reiciendis iste.</p>
            <div className='lower'></div>
          </div>
        </div>
        {data.data.results.map((series, idx) => <div key={idx} className='col-md-2 my-2'>
        <Link to={`/seriesdetails/${series.id}`}>
          <div className="series imghov position-relative">
            <img className='w-100 rounded-3' src={"https://image.tmdb.org/t/p/w500/" + series.poster_path} alt="seriespic" />
            <h6 className='rating p-2 rounded-circle'>{(series.vote_average).toFixed(1)}</h6>
            <h6 className='mt-3'>{series.name}</h6>
          </div>
          </Link>
        </div>)}
      </div>
    </div> 
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-4">
          <Link to={"/topratedseries"}>
          <div className="trending">
            <div className='upper'></div>
            <h5>Top Rated Series to watch now</h5>
            <p className='text-muted'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Illo fuga quibusdam expedita quos non id optio nisi excepturi nostrum iusto maxime necessitatibus soluta suscipit, exercitationem laborum accusantium commodi, reiciendis iste.</p>
            <div className='lower'></div>
          </div>
          </Link>
        </div>
        {topRatedSeries.map((series, idx) => <div key={idx} className='col-md-2 my-2'>
        <Link to={`/seriesdetails/${series.id}`}>
          <div className="series imghov position-relative">
            <img className='w-100 rounded-3' src={"https://image.tmdb.org/t/p/w500/" + series.poster_path} alt="seriespic" />
            <h6 className='rating p-2 rounded-circle'>{(series.vote_average).toFixed(1)}</h6>
            <h6 className='mt-3'>{series.name}</h6>
          </div>
          </Link>
        </div>)}
      </div>
    </div></>: <div className='vh-100 d-flex justify-content-center align-items-center'>
    <MoonLoader color="white"/>
    </div>}
</>
}

export default Series;